<div
	class="bg-light-grey h-[890px] rounded-lg max-mobile:py-[7px] max-mobile:px-[12px] py-3"
>
	<div class="flex justify-between mt-3">
		<img
			(click)="isFlipped.emit(false)"
			class="ltr:lg:ml-24px ltr:ml-[8px] rtl:mr[8px] rtl:lg:mr-24px ltr:mr-2 rtl:ml-2 rtl:rotate-180 cursor-pointer md:mt-0 mt-1 md:w-[25px] w-[17px]"
			src="assets/images/arrow-left.svg"
			alt="icon"
		/>
		<p class="font-DIN-bold font-bold text-[18px] mb-1 text-[#4E4B66]">
			{{ 'PAYOUT.PAYOUT_LIST.TRANSACTION' | translate }}
		</p>
		<div></div>
	</div>
	<div class="flex justify-center">
		<p class="text-[#4E4B66] ltr:ml-[35px] text-[16px] mb-0">
			#{{ clientDeatailsData?.id }}
		</p>
	</div>
	<div class="mt-3 py-5 px-10">
		<div class="w-full lg:flex gap-2 rounded-t-[12px] bg-white">
			<div class="py-[8px] px-[24px] flex gap-[8px] w-full">
				<img class="my-auto" src="./assets/images/user.svg" alt="" srcset="" />

				<div>
					<p class="text-[#6E7191] text-[12px] mb-0">
						{{ 'PAYOUT.PAYOUT_LIST.CLIENT_NAME' | translate }}
					</p>
					<p class="text-[#4E4B66] text-[16px] mb-0">
						{{ clientDeatailsData?.clientName }}
					</p>
				</div>
			</div>
			<div class="py-[8px] px-[24px] flex gap-[8px] w-full">
				<img
					class="my-auto"
					src="./assets/images/calendar.svg"
					alt=""
					srcset=""
				/>

				<div>
					<p class="text-[#6E7191] text-[12px] mb-0 whitespace-nowrap">
						{{ 'PAYOUT.PAYOUT_LIST.REQUEST_DATE' | translate }}
					</p>
					<p class="text-[#4E4B66] text-[16px] mb-0 whitespace-nowrap">
						{{ clientDeatailsData?.requestDate | date : 'dd/MM/yyyy' : 'UTC' }}
					</p>
					<p class="text-[#4E4B66] text-[16px] mb-0">
						{{ clientDeatailsData?.requestDate | date : ' hh:mm a' : 'UTC' }}
					</p>
				</div>
			</div>
			<div class="py-[8px] px-[24px] flex gap-[8px] w-full">
				<img
					class="my-auto"
					src="./assets/images/calendar.svg"
					alt=""
					srcset=""
				/>

				<div>
					<p
						*ngIf="clientDeatailsData?.payoutStatus == 2"
						class="text-[#6E7191] text-[12px] mb-0"
					>
						{{ 'PAYOUT.PAYOUT_LIST.PAYOUT_DATE' | translate }}
					</p>
					<p
						*ngIf="clientDeatailsData?.payoutStatus == 3"
						class="text-[#6E7191] text-[12px] mb-0"
					>
						{{ 'PAYOUT.PAYOUT_LIST.CANCEL_DATE' | translate }}
					</p>
					<p class="text-[#4E4B66] text-[16px] mb-0 whitespace-nowrap">
						{{ clientDeatailsData?.actionDate | date : 'dd/MM/yyyy' : 'UTC' }}
					</p>
					<p class="text-[#4E4B66] text-[16px] mb-0">
						{{ clientDeatailsData?.actionDate | date : 'hh:mm a' : 'UTC' }}
					</p>
				</div>
			</div>
			<div class="py-[8px] px-[24px] flex gap-[8px] w-full">
				<img
					class="h-[24px] w-[24px] my-auto"
					src="./assets/images/dollar-circle.png"
					alt=""
					srcset=""
				/>

				<div>
					<p class="text-[#6E7191] text-[12px] mb-0">
						{{ 'PAYOUT.PAYOUT_LIST.REQUEST_AMOUNT' | translate }}
					</p>
					<p *ngIf="countryId == 224" class="text-[#4E4B66] text-[16px] mb-0">
						{{ clientDeatailsData?.requestedAmount }}
						{{ translate.currentLang === 'ar' ? 'ج.م' : 'EGP' }}
					</p>

					<p *ngIf="countryId == 103" class="text-[#4E4B66] text-[16px] mb-0">
						{{ clientDeatailsData?.requestedAmount }}
						{{ translate.currentLang === 'ar' ? 'ر.س' : 'SAR' }}
					</p>
				</div>
			</div>
		</div>
		<hr class="w-full" />
		<div class="w-full lg:flex rounded-b-[12px] bg-white gap-2">
			<div class="py-[8px] px-[24px] flex gap-[8px] w-full">
				<img
					class="h-[24px] w-[24px] my-auto"
					[src]="
						clientDeatailsData?.payoutMethod?.id == 1
							? 'assets/images/bank.png'
							: clientDeatailsData?.payoutMethod?.id == 2
							? 'assets/images/Fawri.svg'
							: 'assets/images/instapay.svg'
					"
					alt=""
					srcset=""
				/>

				<div>
					<p class="text-[#6E7191] text-[12px] mb-0">
						{{ 'PAYOUT.PAYOUT_LIST.PAYOUT_METHOD' | translate }}
					</p>
					<p class="text-[#4E4B66] text-[16px] mb-0">
						{{
							translate.currentLang === 'ar'
								? clientDeatailsData?.payoutMethod?.nameAr
								: clientDeatailsData?.payoutMethod?.nameEn
						}}
					</p>
				</div>
			</div>
			<div
				*ngIf="clientDeatailsData?.payoutMethod?.id == 1"
				class="py-[8px] px-[24px] flex gap-[8px] w-full"
			>
				<img
					class="h-[24px] w-[24px] my-auto"
					src="./assets/images/bank.png"
					alt=""
					srcset=""
				/>

				<div>
					<p class="text-[#6E7191] text-[12px] mb-0">
						{{ 'PAYOUT.PAYOUT_LIST.BANK_NAME' | translate }}
					</p>
					<p class="text-[#4E4B66] text-[16px] mb-0 whitespace-nowrap">
						{{ clientDeatailsData?.bankName }}
					</p>
				</div>
			</div>
			<div
				*ngIf="clientDeatailsData?.payoutMethod?.id == 1"
				class="py-[8px] px-[24px] flex gap-[8px] w-full"
			>
				<img
					class="my-auto"
					src="./assets/images/receipt-2.png"
					alt=""
					srcset=""
				/>

				<div>
					<p class="text-[#6E7191] text-[12px] mb-0">
						{{ 'PAYOUT.PAYOUT_LIST.ACC_NUMBER' | translate }}
					</p>
					<p class="text-[#4E4B66] text-[16px] mb-0 whitespace-nowrap">
						{{ clientDeatailsData?.accountNumber }}
					</p>
				</div>
			</div>
			<div
				*ngIf="clientDeatailsData?.payoutMethod?.id == 1"
				class="py-[8px] px-[24px] flex gap-[8px] w-full"
			>
				<img
					class="h-[24px] w-[24px] my-auto"
					src="./assets/images/bank.png"
					alt=""
					srcset=""
				/>

				<div>
					<p class="text-[#6E7191] text-[12px] mb-0">
						{{ 'PAYOUT.PAYOUT_LIST.ACC_NAME' | translate }}
					</p>
					<p class="text-[#4E4B66] text-[16px] mb-0">
						{{ clientDeatailsData?.accountName }}
					</p>
				</div>
			</div>
			<div
				*ngIf="clientDeatailsData?.payoutMethod?.id == 2"
				class="py-[8px] px-[24px] flex gap-[8px] w-full"
			>
				<img
					class="h-[24px] w-[24px] my-auto"
					src="./assets/images/receipt-2.png"
					alt=""
					srcset=""
				/>

				<div>
					<p class="text-[#6E7191] text-[12px] mb-0">
						{{ 'PAYOUT.PAYOUT_LIST.FAWRY_ACC_NUMBER' | translate }}
					</p>
					<p class="text-[#4E4B66] text-[16px] mb-0">
						{{ clientDeatailsData?.fawryAccount }}
					</p>
				</div>
			</div>

			<div
				*ngIf="clientDeatailsData?.payoutMethod?.id == 3"
				class="py-[8px] px-[24px] flex gap-[8px] w-full"
			>
				<img
					class="h-[24px] w-[24px] my-auto"
					src="./assets/images/receipt-2.png"
					alt=""
					srcset=""
				/>

				<div>
					<p class="text-[#6E7191] text-[12px] mb-0">
						{{ 'PAYOUT.PAYOUT_LIST.INSTA_ID' | translate }}
					</p>
					<p class="text-[#4E4B66] text-[16px] mb-0">
						{{ clientDeatailsData?.instapayAccount }}
					</p>
				</div>
			</div>
		</div>
	</div>
	<div class="w-[100%] bg-white py-5 px-10">
		<img
			[src]="
				clientDeatailsData?.attachmentUrl == '' ||
				clientDeatailsData?.attachmentUrl == null
					? 'assets/images/Frame 1000003013.svg'
					: imagePath + '/' + clientDeatailsData?.attachmentUrl
			"
			class="rounded-[8px] w-full h-full"
			alt=""
			srcset=""
		/>

		<div class="my-5">
			<p class="text-[#4E4B66] text-[16px] mb-0">
				{{ 'PAYOUT.PAYOUT_LIST.NOTES' | translate }}
			</p>
			<p class="text-[#6E7191] text-[14px] mb-0">
				{{ clientDeatailsData?.notes }}
			</p>
		</div>
	</div>
</div>
